import { HostListener, Component, OnInit, Output, AfterContentChecked, ViewChild, ElementRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { ErrorObject } from '../../app/errorhandler/gpiserror-object';
import { ErrorHandlerService } from '../../app/errorhandler/gpiserror-handler.service';
import { IReturnObject } from '../shared/return-object.model';
import { ErrorTypeEnum, StatusEnum } from '../shared/enums.model';
import { ComponentCanDeactivate } from '../../app/shared/page.pendingchangesguard';
import { UserManagementService } from './user-management.service';
import { UserHandling } from '../shared/user-handling';
import { ConfirmResult } from '../../app/dialogboxes/shared/confirm.model'
import { InputTimerAction } from '../shared/input-timer-action';
import { UserPruBE } from './shared/user-management.model';
import { AttributeListBE } from '../shared/attribute-list.model';
import { SetFocus } from '../../app/shared/setFocus';
import { ChineseChangeValueService } from '../chinese-change-value.service';


@Component({
    moduleId: module.id,
    selector: 'user-management',
    templateUrl: 'user-management.html',
    providers: [UserManagementService],
})
export class UserManagementComponent implements OnInit, AfterContentChecked, ComponentCanDeactivate {
    showSpinner: boolean = false;
    viewPruUserListSpinner: boolean = false;
    pruList: AttributeListBE[] = [];
    pruUserList: UserPruBE[];
    selectedPruUser: UserPruBE = new UserPruBE();
    searchPruUserText: string = "";
    selectedListPruId: number = -1;
    user: UserHandling = new UserHandling();
    isDirty: boolean = false;
    errorObj: ErrorObject = null;
    setFocus: SetFocus = new SetFocus();
    isFocusSet: boolean = false;
    showEditArea: boolean = false;

    // confirm dialog
    @ViewChild('cDlg') cdlg: ElementRef;
    dialogAction: string;
    dialogBtnType: string;
    dialogAppliesTo: string = "";
    dialogAppliesToId: number = -1;
    currentDlg: NgbModalRef;
    confirmDlgText: string = "";
    @ViewChild('validate') validate: ElementRef;
    constructor(
        private pruUserService: UserManagementService,
        private modalService: NgbModal,
        private errHandler: ErrorHandlerService,
        public ChineseChangeValueService:ChineseChangeValueService
    ) {
        errHandler.errorEvent.subscribe((err: ErrorObject) => this.onError(err));
    }

    ngOnInit() {
        this.loadPruList();
        this.loadPruUserListByUserId();
    }
     
    ngAfterContentChecked() {
        this.isFocusSet = this.setFocus.to("searchPruUser", this.isFocusSet);
    }

    @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean {
        return !this.isDirty;
    }


    // ----------------------------------------------------------
    // Fetch data
    // ----------------------------------------------------------
    loadPruList() {
        this.viewPruUserListSpinner = true;
        this.errHandler.emitErrorObject(null);
        this.pruUserService.getPruList()
            .subscribe(returnObject => this.loadPruListResponse(returnObject));
    }

    loadPruListResponse(returnObject: IReturnObject) {
        this.viewPruUserListSpinner = false;
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'PruUserComponent.loadPruList', returnObject.ErrorType);
        else
            this.pruList = returnObject.DataList;
    }
    
    loadPruUserListByUserId() {
        this.viewPruUserListSpinner = true;
        this.errHandler.emitErrorObject(null);
        this.pruUserService.getPruUsersListForUser(this.user.UserId)
            .subscribe(returnObject => this.loadPruUserListByUserIdResponse(returnObject));
    }

    loadPruUserListByUserIdResponse(returnObject: IReturnObject) {
        this.viewPruUserListSpinner = false;
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'PruUserComponent.loadPruUserListResponse', returnObject.ErrorType);
        else
            this.pruUserList = returnObject.DataList;

        this.selectedListPruId = this.pruUserList.length > 0
            ? this.pruUserList[0].PruId
            : -1;
    }
    
    loadPruUserListByPruId() {
        this.viewPruUserListSpinner = true;
        this.errHandler.emitErrorObject(null);
        this.pruUserService.getPruUsersListForPruId(this.selectedListPruId)
            .subscribe(returnObject => this.loadPruUserListByUserIdResponse(returnObject));
    }

    loadPruUserListByPruIdResponse(returnObject: IReturnObject) {
        this.viewPruUserListSpinner = false;
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'PruUserComponent.loadPruUserListResponse', returnObject.ErrorType);
        else
            this.pruUserList = returnObject.DataList;
    }
    openOnSearchValidateDlg(text: string) {
        this.errHandler.emitErrorObject(null);
        this.dialogAction = "searchfail";
        this.dialogBtnType = "info";
        this.dialogAppliesTo = 'User ';
        this.confirmDlgText = text;
        this.dialogAppliesToId = -1;
        this.currentDlg = this.modalService.open(this.validate, { size: 'sm' });
      }
      cancel() {
        this.currentDlg.close()
     }
    findUser(){
        this.showEditArea = false;
        
        this.errHandler.emitErrorObject(null);
        if(this.searchPruUserText.length>0)
        {
            this.showSpinner = true;
            this.pruUserService.getPruUser(this.searchPruUserText)
            .subscribe(returnObject => this.findUserResponse(returnObject));
        }
        else{
            this.openOnSearchValidateDlg("Please enter the User Id") ;
                return false;
            
        }
        
    }

    findUserResponse(returnObject: IReturnObject) {
        this.showSpinner = false;
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'PruUserComponent.findUserResponse', returnObject.ErrorType);

        if (returnObject.DataList.length == 0) {
            this.findUserInAd();
        }
        else {
            let foundUser: UserPruBE = returnObject.DataList[0];
            this.selectedPruUser = new UserPruBE();
            this.selectedPruUser.Id = foundUser.Id;
            this.selectedPruUser.UserId = foundUser.UserId;
            this.selectedPruUser.UserName = foundUser.UserName;
            this.selectedPruUser.PruId = foundUser.PruId;
            this.selectedPruUser.IsApprover = foundUser.IsApprover;
            this.showEditArea = true;
        }
    }

    findUserInAd(){
        this.showSpinner = true;
        this.errHandler.emitErrorObject(null);
        this.pruUserService.getADUser(this.searchPruUserText)
            .subscribe(returnObject => this.findUserInAdResponse(returnObject));
    }

    findUserInAdResponse(returnObject: IReturnObject) {
        this.showSpinner = false;
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, '', returnObject.ErrorType);
            return;
        }
        
        if (returnObject.DataList.length == 0) {
            this.errHandler.emitError(returnObject.ErrorMsg, '', ErrorTypeEnum.Info);
            this.selectedPruUser = new UserPruBE();
            }
        else {
            let foundUser: UserPruBE = returnObject.DataList[0];
            this.selectedPruUser = new UserPruBE();
            this.selectedPruUser.UserId = foundUser.UserId;
            this.selectedPruUser.UserName = foundUser.UserName;
            this.showEditArea = true;
        }
    }
    

    // ----------------------------------------------------------
    // Actions
    // ----------------------------------------------------------
    selectPruUser(PruUser: UserPruBE) {
        this.selectedPruUser = new UserPruBE();
        this.selectedPruUser.Id = PruUser.Id;
        this.selectedPruUser.UserName = PruUser.UserName;
    }

    delete(selectedUser: UserPruBE) {
        this.selectedPruUser = selectedUser;
        this.openConfirmDeleteDlg();
    }

    doDelete() {
        this.showSpinner = true;
        this.errHandler.emitErrorObject(null);
        this.pruUserService.deletePruUser(this.user.UserId ,this.selectedPruUser.Id)
            .subscribe(returnObject => this.deleteResponse(returnObject));
    }

    deleteResponse(returnObject: IReturnObject) {
        this.pruUserList = returnObject.DataList;
        this.selectedPruUser = new UserPruBE();
        this.isDirty = false;
        this.showSpinner = false;
    }

    updatePruUser() {
        this.showSpinner = true;
        this.errHandler.emitErrorObject(null);
        this.pruUserService.updatePruUser(this.selectedPruUser)
            .subscribe(returnObject => this.updatePruUserResponse(returnObject));
    }

    updatePruUserResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, '', returnObject.ErrorType);
            return;
        }
        
        if (this.selectedPruUser.PruId == this.selectedListPruId){
            var inList = this.pruUserList.find(x=>x.UserId == this.selectedPruUser.UserId );
            if (inList == undefined)
                this.pruUserList.push(this.selectedPruUser);
        }
        else {
            var index = this.pruUserList.findIndex(x=>x.UserId == this.selectedPruUser.UserId );
            if (index != -1)
                this.pruUserList.splice(index,1);
        }

        this.selectedPruUser = new UserPruBE();
        this.isDirty = false;
        this.showSpinner = false;
        this.showEditArea = false;
    }

    editUser(listItem:UserPruBE){
        this.selectedPruUser = listItem;    
        this.showEditArea = true;
        
    }


    // ----------------------------------------------------------
    // Dialog boxes
    // ----------------------------------------------------------
    openConfirmDeleteDlg() {
        this.errHandler.emitErrorObject(null);
        this.dialogAction = "delete";
        this.dialogBtnType = "danger";
        this.dialogAppliesTo = "PruUser ";
        this.dialogAppliesToId = this.selectedPruUser.Id;
        this.currentDlg = this.modalService.open(this.cdlg, { size: 'sm' });
    }

    onConfirmDlgNotify(command: ConfirmResult): void {
        this.closeDlg();
        if (command.Action == "delete") {
            this.doDelete();
        }
        else {
            this.closeDlg();
        }
    }

    closeDlg() {
        this.currentDlg.close();
    }

    
    // ----------------------------------------------------------
    // MISC
    // ----------------------------------------------------------
    setDirty() {
        this.isDirty = true;
    }

    onError(error: ErrorObject) {
        this.errorObj = this.errHandler.getError();
    }

    isUpdateDisabled(): boolean {
        let isEnabled: boolean = this.isDirty
            && this.selectedPruUser.UserName.length > 0
            && this.selectedPruUser.UserId.length > 0
            && this.selectedPruUser.PruId > 0;

        return !isEnabled;
    }

    // ------------------------------------------------------
    //Access rights control
    // ------------------------------------------------------
    isPageAccessible(): boolean {
        return (this.user.IsPackagingAdmin
            || this.user.IsDeveloper);
    }
}



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/user-management/user-management.component.ts